/* FIXME
 * We're using a fork of p-queue with a patch that resolves the following issue:
 * https://github.com/sindresorhus/p-queue/issues/219
 * Once the following PR is merged we should move back to the original library:
 * https://github.com/sindresorhus/p-queue/pull/220
 */
import PQueue from "@nmann/p-queue";

export type TaskId = string;
export type TaskRunFunc<T> = (args: TaskRunFuncArgs) => Promise<T>;
export type TaskRunFuncArgs = { signal?: AbortSignal };

export type EnqueueTaskProps<T> = {
  run: TaskRunFunc<T>;
  priority?: number;
  signal?: AbortSignal;
};

export type TaskRef<T> = {
  id: TaskId;
  promise: Promise<T>;
  abortController: AbortController;
};

export type AsyncTaskQueueOptions = {
  concurrencyLimit: number;
  intervalLimit?: number;
  interval?: number;
};

export default class AsyncTaskQueue<T> {
  public static DEFAULT_PRIORITY = 0;

  private queue;
  private previousTaskId = 0;
  private nextTaskId(): TaskId {
    return (this.previousTaskId++).toString();
  }

  constructor(options: AsyncTaskQueueOptions) {
    this.queue = new PQueue({
      concurrency: options.concurrencyLimit,
      ...(options.intervalLimit !== undefined
        ? { intervalCap: options.intervalLimit }
        : {}),
      ...(options.interval !== undefined ? { interval: options.interval } : {}),
    });
  }

  enqueue(props: EnqueueTaskProps<T>): TaskRef<T> {
    const id = this.nextTaskId();
    const abortController = this.mergedAbortController(props.signal);
    const promise = this.queue.add(props.run, {
      id: id,
      priority: this.translatePriority(props.priority ?? AsyncTaskQueue.DEFAULT_PRIORITY),
      signal: abortController.signal,

      // NOTE: we don't use the timeout function of p-queue.. but.. the timeout
      // feature of p-queue alters the return type of the promise from
      // Promise<T> to Promise<T | void> (because if you don't throw on timeout
      // you resolve without a value). So here we are... pleasing TypeScript..
      // See: https://github.com/sindresorhus/p-queue/blob/eda5a8490f8d25595de4c74bfe3e250ed397ffcd/source/index.ts#L277
      throwOnTimeout: true,
    });

    return {
      id,
      promise,
      abortController,
    };
  }

  //setPriority(id: TaskId, priority: number) {
  //  this.queue.setPriority(id, this.translatePriority(priority))
  //}

  private translatePriority(priority: number) {
    return priority * -1;
  }

  private mergedAbortController(originalSignal?: AbortSignal) {
    const controller = new AbortController();
    if (originalSignal) {
      originalSignal.addEventListener(
        "abort",
        () => {
          controller.abort(originalSignal.reason);
        },
        { signal: controller.signal },
      );
    }
    return controller;
  }
}
